import React from 'react';
import { FILTER_COLLATION, FILTER_OPERATION, ModelRenderer } from '@veeam/core';
import { BasicFilter } from "../../BasicFilter";
function parseValue(value) {
    if (!value || !Array.isArray(value)) {
        return [];
    }
    return value;
}
export function toolbarBasicFilter(_a) {
    var title = _a.title, property = _a.property, _b = _a.groupId, groupId = _b === void 0 ? '' : _b, _c = _a.operation, operation = _c === void 0 ? FILTER_OPERATION.in : _c, _d = _a.collation, collation = _d === void 0 ? FILTER_COLLATION.ignorecase : _d, items = _a.items, decorators = _a.decorators, textAllButton = _a.textAllButton, hasAllButton = _a.hasAllButton;
    return {
        decorators: decorators,
        render: function (model) {
            return (React.createElement(ModelRenderer, { model: model, render: function (_a) {
                    var value = _a.value;
                    return (React.createElement(BasicFilter, { label: title.replace(/:$/, ''), value: parseValue(value.filters.getFilterValue({ property: property, groupId: groupId })), hasAllButton: hasAllButton, textAllButton: textAllButton, onChange: function (value) {
                            model.setFilter({ property: property, groupId: groupId }, {
                                operation: operation,
                                collation: collation,
                                value: value || []
                            });
                        }, buttons: items }));
                } }));
        }
    };
}
//# sourceMappingURL=toolbarBasicFilter.js.map